import RowList from "../../Row_List/RowList";
import Loading from "../../Loading/Loading";


export default function Home({ showLoading, listHome ,isGuest}) {

    return (
        <div className="container">
            <div className="main_list">
                {showLoading ?
                    <Loading />
                    : listHome.map((row, rowIndex) => {
                        return (
                            <RowList
                                key={row.id}
                                title={row.title}
                                type={row.type}
                                row={row}
                                array={row.content}
                                rowIndex={rowIndex}
                                isGuest={isGuest}

                            />
                        )
                    })}
            </div>
        </div>

    )
}